export default __webpack_public_path__ + "static/media/lawdisk.5157bc9a.png";